// Dicionário simples de classificação de itens por categoria.
// Não é IA — é uma heurística determinística por palavras-chave, alinhada com o MVP
// (ver CLAUDE.md: "Não usar LLM no chat do MVP — parsing determinístico resolve").
//
// Cada categoria abaixo lista palavras/trechos comuns encontrados no nome do item.
// A busca é por "contém", então plural/gênero simples (ex: "banana"/"bananas") já funciona.

import { normalizeText } from '../utils/format';

const CATEGORY_KEYWORDS: Record<string, string[]> = {
  'Cereais e Grãos': [
    'arroz', 'feijao', 'lentilha', 'grao de bico', 'grao-de-bico', 'ervilha',
    'aveia', 'granola', 'quinoa', 'milho', 'fuba', 'farinha', 'macarrao',
    'massa', 'espaguete', 'polenta', 'tapioca', 'amido de milho',
  ],
  Laticínios: [
    'leite', 'queijo', 'iogurte', 'requeijao', 'manteiga', 'margarina',
    'nata', 'creme de leite', 'coalhada', 'ricota', 'mussarela',
  ],
  Padaria: [
    'pao', 'baguete', 'bisnaguinha', 'croissant', 'bolo', 'torrada',
    'biscoito', 'bolacha', 'rosca',
  ],
  Carnes: [
    'carne', 'frango', 'peito de frango', 'file', 'bife', 'linguica',
    'salsicha', 'bacon', 'peixe', 'salmao', 'tilapia', 'camarao',
    'costela', 'picanha', 'alcatra', 'moida', 'suino', 'porco',
  ],
  Hortifruti: [
    'banana', 'maca', 'laranja', 'mamao', 'uva', 'melancia', 'melao',
    'abacaxi', 'morango', 'limao', 'tomate', 'cebola', 'alho', 'batata',
    'cenoura', 'alface', 'couve', 'brocolis', 'pepino', 'pimentao',
    'abobrinha', 'chuchu', 'mandioca', 'beterraba',
  ],
  Bebidas: [
    'agua', 'suco', 'refrigerante', 'cerveja', 'vinho', 'cafe', 'cha',
    'achocolatado', 'energetico', 'isotonico', 'refresco',
  ],
  Limpeza: [
    'detergente', 'sabao', 'amaciante', 'agua sanitaria', 'desinfetante',
    'multiuso', 'esponja', 'saco de lixo', 'alvejante', 'limpa vidro',
    'veja', 'cif', 'lustra moveis', 'papel toalha',
  ],
  Higiene: [
    'sabonete', 'shampoo', 'condicionador', 'papel higienico', 'creme dental',
    'pasta de dente', 'escova de dente', 'desodorante', 'absorvente',
    'fralda', 'aparelho de barbear', 'algodao', 'cotonete', 'fio dental',
  ],
  Congelados: [
    'congelado', 'sorvete', 'lasanha congelada', 'nuggets', 'hamburguer',
    'polpa de fruta', 'acai',
  ],
};

/**
 * Sugere uma categoria com base no nome digitado do item.
 * Retorna null se nenhuma palavra-chave conhecida for encontrada.
 */
export function suggestCategory(itemName: string): string | null {
  const normalized = normalizeText(itemName).trim();
  if (!normalized) return null;

  for (const [category, keywords] of Object.entries(CATEGORY_KEYWORDS)) {
    if (keywords.some((keyword) => normalized.includes(keyword))) {
      return category;
    }
  }
  return null;
}
